class ToTop {
  constructor() {
    this.el = document.getElementById("jsToTop");
    this.timer = 100;
    this.timeout = null;
    this.className = "sticky";
    this.Init();
    this.Click();
    this.Scroll();
  }

  Click() {
    if(this.el) {
      this.el.addEventListener("click", (e) => {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      });
    }
  }

  Init() {
    if(this.el) {
      if (window.scrollY >= 100) {
        this.el.classList.add(this.className);
      } else {
        this.el.classList.remove(this.className);
      }
    }
  }

  Scroll () {
    window.addEventListener("scroll", () => {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(this.Init(), this.timer);
    });    
  }
}

window.addEventListener("load", () => {
  let toTop = new ToTop();
});